import { GUEST, USER } from "../../constans/roles";
import { registerUser } from "../../utils/api/userApi";

const MISSING_EMAIL_MESSAGE = "Nie podano maila!";
const MISSING_PASSWORD_MESSAGE = "Nie podano hasla!";
const MISSING_ROLE_MESSAGE = "Nie podano roli!";

const REGISTER_SUCCESS_MESSAGE = "Dodano uzytkownika!";
const REGISTER_FAILURE_FALLBACK = "Nie udalo sie dodac uzytkownika.";

export const buildUserRoles = (role) => {
  if (role === USER) {
    return [GUEST, USER];
  }

  return [GUEST];
};

export const validateRegisterForm = ({ email, password, role }) => {
  if (!email) return MISSING_EMAIL_MESSAGE;
  if (!password) return MISSING_PASSWORD_MESSAGE;
  if (!role) return MISSING_ROLE_MESSAGE;
  return "";
};

export async function submitRegisterForm({ email, password, role }) {
  const validationMessage = validateRegisterForm({ email, password, role });
  if (validationMessage) {
    alert(validationMessage);
    return false;
  }

  const response = await registerUser({
    login: email,
    password,
    role: buildUserRoles(role),
  });

  if (response.ok) {
    alert(REGISTER_SUCCESS_MESSAGE);
    return true;
  }

  alert(response?.data?.message || REGISTER_FAILURE_FALLBACK);
  return false;
}
